

import { useState,useEffect } from 'react';
import useSWR, { mutate }    from 'swr';
import { API_BASE } from '../../api';

const COMMENTS_URL = `${API_BASE}/comments`;

const CommentList = ({ commentChange }) => {
    const [visibleComments, setVisibleComments] = useState(10);
   
    const fetcher = async (url) => {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    };

    const { data: comments, error,isLoading } = useSWR(COMMENTS_URL, fetcher,{
         revalidateIfStale: false,
         revalidateOnFocus: false,
         revalidateOnReconnect: false,
         onSuccess: () => commentChange=false,
         onError: () => commentChange=true
        
        
    });

    useEffect(() => {
        if(commentChange){
        mutate(COMMENTS_URL);
        }
    }, [commentChange]);

    if (error) {
        return <p>Σφάλμα: {error.message}</p>;
    }

    if (isLoading) {
        return <><p>Φόρτωση σχολίων...</p><div style={{ textAlign: 'center', alignItems: 'center' }}> <div className='cloader' ></div></div></> ;
    }

       
    
    const loadMore = () => {
        setVisibleComments(prevVisibleComments => prevVisibleComments + 10);
    };

    
    
    const sortedComments = comments
        .sort((a, b) => new Date(b.date) - new Date(a.date))
        .slice(0, visibleComments);

    return (
        <div style={{ textAlign: 'center', alignItems: 'center' }}>
            <br />
            <p>Τα σχόλιά σας:</p><br />
            {sortedComments.length > 0 ? (
                sortedComments.map((comment, index) => (
                    <div className='comment' key={index} style={{ alignItems: 'center' }}>
                        <p><strong>Χρήστης:</strong> {comment.user}</p>
                        <p><strong>Σχολίασε:</strong> {comment.comment}</p>
                        <p><strong>Στις:</strong> {comment.date}</p>
                        <hr />
                    </div>
                ))
            ) : (
                <p>Δεν βρέθηκαν σχόλια.</p>
            )}
            <br />
            {comments.length > visibleComments && (<div>
    <button className='cform-submit' onClick={loadMore}>Περισσότερα...</button><br /> </div>
)}
        </div>
     
    );

    
};

export default CommentList;



